import moment from 'moment'

import Vue from 'vue'

const showToastSuccess = (text, className, action, options) => {
  if (!text) return

  Vue.toasted.success(text, {
    theme: 'bubble',
    position: 'bottom-right',
    className: className || 'custom-toast__success',
    action: action || {
      text: '',
      onClick: (e, toastObject) => {
        toastObject.goAway(0)
      },
    },
    ...options,
  })
}

const showToastError = (text, className, action, options) => {
  if (!text) return

  Vue.toasted.error(text, {
    theme: 'bubble',
    position: 'bottom-right',
    className: className || 'custom-toast__error',
    action: action ? {
      text: '',
      onClick: (e, toastObject) => {
        toastObject.goAway(0)
      },
    } : '',
    ...options,
  })
}

const isoDate = (value) => {
  return moment(value).format("YYYY-MM-DD")
}

const isoDateTime = (value) => {
  return moment(value).format("YYYY-MM-DD HH:mm:ss")
}

const isValidUrl = (string) => {
  try {
    new URL(string)
    
    return true
  } catch (_) {
    return false
  }
}

function convertToTimestampTz(dateTimeStr) {
  return moment(dateTimeStr).format()
}

function convertToDateTimeLocal(dateTimeStr) {
  return moment(dateTimeStr).format("YYYY-MM-DDTHH:mm")
}

// AHA-38266: a team gets the Enterprise badge when it has a sales-assisted contract
// flagged "Is Enterprise = Yes". `teamid`/`is_enterprise` are the wire field names —
// Redshift lower-cases result columns but keeps underscores, so `is_enterprise` stays
// as-is (unlike `teamId` → `teamid`). Repeated across the four Team/User views, so it
// lives here.
const hasEnterpriseContract = (salesContracts, teamId) => (
  Array.isArray(salesContracts)
  && salesContracts.some(contract => contract.teamid === teamId && contract.is_enterprise === true)
)

export default {
  isoDate,
  isoDateTime,
  showToastSuccess,
  showToastError,
  isValidUrl,
  convertToTimestampTz,
  convertToDateTimeLocal,
  hasEnterpriseContract,
}